import './SeptimLoadingSpinner.css';
import { useState } from 'react';
import clsx from 'clsx';

interface SeptimLoadingSpinnerProps {
  height?: string;
  className?: string;
}

// Monotonic counter gives every mount a unique cache-busting query, so the gif
// is always refetched and its animation restarts from frame 0 on each mount.
let mountCounter = 0;

const SeptimLoadingSpinner = ({
  height,
  className,
}: SeptimLoadingSpinnerProps) => {
  const [cacheBuster] = useState(() => {
    mountCounter += 1;

    return mountCounter;
  });
  const src = `/images/loading.gif?${cacheBuster}`;

  return (
    <div
      className={clsx('septim-loading-spinner-container', className)}
      style={height !== undefined ? { height } : undefined}
    >
      <img
        key={cacheBuster}
        src={src}
        className="septim-loading-spinner"
        width={150}
        height={150}
        decoding="sync"
      />
    </div>
  );
};

export default SeptimLoadingSpinner;
